import React, {Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './Grade.css'
import format from '../../helpers/format'
// import ReactTooltip from 'react-tooltip'

@CSSModules(Styles,{allowMultiple:false})
export default class Grade extends Component {
  static propTypes = {
    grade: PropTypes.number.isRequired,
    large: PropTypes.bool,
    block: PropTypes.bool,
    blocksmall: PropTypes.bool,
    square: PropTypes.bool,
    // medium: PropTypes.bool,
  }
  constructor(props){
    super(props);
  }
  render() {
    const { grade } = this.props
    const charGrade = format.score(grade)
    const safeGrade = charGrade === 'N/A' ? 'NA' : charGrade

    const addSuffix = (s) => {
      return s ? `grade-${safeGrade}-${s}` : `grade-${safeGrade}`
    }
    let style = addSuffix(null)
    if (this.props.large) {
      style = addSuffix('large')
    } else if (this.props.block) {
      style = addSuffix('block')
    } else if (this.props.blocksmall) {
      style = addSuffix('block-small')
    } else if (this.props.square) {
      style = addSuffix('square')
    }

    let wrapStyle = 'grade-wrap'
    if (this.props.large || this.props.block) {
      wrapStyle = 'grade-wrap-large'
    } else if (this.props.square) {
      wrapStyle = 'grade-wrap-square'
    }

    const shield = require('../../../static/images/icn-engagement-shield.svg')
    //
    return <div styleName={wrapStyle}>
      <div styleName={style} >
        {
          charGrade === 'E' ?
            <img
              src={shield}
              alt='Known Sustainability Engager'
              styleName='grade-engagement-icon'
            /> :
            charGrade
        }
      </div>
    </div>
  }
}

